import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoExternal = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>External</title>
    <path
      d="M24.998 18.422v6.565a3.428 3.428 0 0 1-3.428 3.428H8.999A3.425 3.425 0 0 1 5.57 24.99V12.415A3.428 3.428 0 0 1 9 8.987h6.932M20.998 4.986h8v8M14.332 19.653 28.998 4.986"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoExternal;
